import { Component, Inject, OnInit } from '@angular/core';
import Rollbar from 'rollbar';
import { User } from 'src/app/models/user';
import { AuthService } from 'src/app/services/auth/auth.service';
import { MixpanelService } from 'src/app/services/mixpanel/mixpanel.service';
import { UserService } from 'src/app/services/user/user.service';
import { RollbarService } from 'src/app/util/rollbar';

@Component({
  selector: 'app-set-password',
  templateUrl: './set-password.component.html',
  styleUrls: ['./set-password.component.scss'],
})
export class SetPasswordComponent implements OnInit {
  public user: User;
  public message: string;
  public error: string;
  private sending = false;

  public sendPasswordResetEmail(): void {
    // One email per request: ignore clicks while the last one is still being sent
    if (this.sending) {
      return;
    }
    this.sending = true;
    this.authService.sendPasswordResetEmail().subscribe(
      () => {
        this.sending = false;
        this.error = '';
        this.message = 'Password reset email sent. Check your inbox for the reset link.';
        this.mixpanelService.track('Action: Set Password Email Sent');
      },
      () => {
        this.sending = false;
        this.message = '';
        this.error = 'Unable to send password reset email';
        this.rollbar.error(
          'Could not send password reset email when setting password for notifications user'
        );
      }
    );
  }

  constructor(
    private authService: AuthService,
    private userService: UserService,
    private mixpanelService: MixpanelService,
    @Inject(RollbarService) private rollbar: Rollbar
  ) { }

  ngOnInit(): void {
    this.userService.currentUser()?.subscribe((data) => {
      this.user = data;
    });
  }
}
